module.exports = __webpack_public_path__ + "images/application/balance-76889305.svg";